<template>
   <div class="testimonial-container" :class="{ lightbg: bgLight }">
      <h2 class="testimonial__heading">{{ content.header }}</h2>
      <div class="row">
         <div
            v-for="(item, index) in content.body ? content.body : content.cards.slice(0, 4)"
            :key="index"
            class="col-sm-12  col-xl-6 testimonial-card"
         >
            <div class="card shadow-card">
               <div class="card-body client-container">
                  <!-- <img src="" alt="" class="client-image" /> -->
                  <div class="client">
                     <p class="client__description">
                        {{ item.quote }}
                     </p>
                     <div class="client__details">
                        <p class="client__details-name">{{ item.name }},</p>
                        <span :class="['client__details-company', item.logo]"></span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <a
         v-if="content.ctas && !showCustomBtns"
         :href="content.ctas[0].link"
         class="btn btn-primary-grad testimonial__cust-btn"
         @click.prevent="goTo(content.ctas[0].link)"
         >{{ content.ctas[0].header }}</a
      >
      <div v-if="showCustomBtns" class="btn-container text-center mt-3">
         <div
            class="btn btn-primary-grad mr-1 mb-1"
            @click="$router.push('/download').catch(() => {})"
         >
            Download Trial
         </div>
         <div
            class="btn btn-outline-primary mb-1 "
            @click="modalShowContactSales = !modalShowContactSales"
         >
            Contact Sales
         </div>
      </div>

      <!--Contact Sales-->
      <b-modal v-model="modalShowContactSales" centered hide-footer>
         <ContactSales />
      </b-modal>
   </div>
</template>

<script>
import ContactSales from '../elforms/Sales';

export default {
   name: 'SimpleTestimonial',
   components: { ContactSales },
   props: {
      content: {
         type: Object,
         default: () => {},
      },
      bgLight: {
         type: Boolean,
         default: false,
      },
      showCustomBtns: {
         type: Boolean,
         default: false,
      },
   },
   data: () => ({
      modalShowContactSales: false,
   }),
   methods: {
      goTo(url) {
         this.$router.push(url).catch(err => {});
      },
   },
};
</script>

<style lang="scss" scoped>
.testimonial-container {
   @media (min-width: 1199px) {
      background-image: url(/public/images/svg-world-map.svg);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: top;
   }
   &.lightbg {
      .testimonial-card {
         .shadow-card {
            border: 1px solid #f5f5f5;
         }
      }
   }
   .testimonial__heading {
      line-height: 42px;
      letter-spacing: 0.5px;
      text-align: center;
      margin-bottom: 60px;
   }
   .testimonial-card {
      margin-bottom: 27px;
      display: flex;
      .shadow-card {
         box-shadow: 0 8px 10px 0 rgba(105, 87, 218, 0.06);
      }
   }
   .client-container {
      display: flex;
      position: relative;

      @media (max-width: 576px) {
         flex-direction: column;
         align-content: center;
      }
      @media (min-width: 577px) {
         flex-direction: row;
      }
      .client-image {
         width: 75px;
         height: 77px;
         background-color: teal;
         border-radius: 50%;
         flex-shrink: 0;
         margin-right: 26px;
         margin-top: 2.5rem;
         @media (max-width: 576px) {
            margin: 2.5rem auto 2px auto;
         }
      }
      .client {
         display: flex;
         flex-direction: column;
         &__description {
            line-height: 24px;
            margin: 0;
            color: #686980;
            background-image: url('/public/images/quote.svg');
            background-repeat: no-repeat;
            background-position: 0 1rem;
            padding-top: 3.2rem;
            padding-left: 5px;
            padding-bottom: 55px;
         }
         .client__details {
            display: flex;
            align-items: center;
            margin: 39px 0 15px 0;
            position: absolute;
            bottom: 0;
            left: 29px;
            margin-bottom: 40px;

            &-name {
               margin: 0;
               line-height: 20px;
               font-weight: 600;
               color: #434456;
            }
            &-company {
               margin-left: 5px;
               height: 30px;
            }
         }
      }
   }
   .testimonial__cust-btn {
      width: 317px;
      padding: 13px 24px;
      line-height: 16px;
      font-weight: 600;
      font-size: 15px;
      display: block;
      margin: 28px auto 0;
      @media (max-width: 375px) {
         width: auto;
         padding: 13px 10px;
      }
   }
}

.t-logo-dell {
   background-position: -16px -82px;
}
.t-logo-und {
   background-position: -20px -763px;
}
.t-logo-hsbc {
   background-position: -21px -379px;
}
.t-logo-electricpenguin {
   background-position: -15px -146px;
}
</style>
